import "whatwg-fetch";
import carouselInit from "./carousel.js";
import loadCollectionListeners from "./showcasePage";

export default class LoadMorePage {
    constructor(loadMore) {
        this.dom = { el: loadMore };

        this.assign();
        this.events();

        this.dom.load_more_container.innerHTML = "";
        this.load_more_content(this.dom.live_search.value, 0, false);
    }

    assign() {
        this.dom.load_more = this.dom.el.querySelector(".js-load-more");
        this.dom.load_more_container = this.dom.el.querySelector(
            ".js-load-more-container"
        );
        this.dom.live_search = this.dom.el.querySelector("#live-search");
        this.i = 0;
        this.type = this.dom.load_more.dataset.type;
        this.endpoint =
            this.type === "news"
                ? "/umbraco/surface/paging/articles?brandId=1&"
                : "/umbraco/surface/paging/showcase?brandId=1&";
        this.next = this.type === "news" ? 3 : 6;
    }

    load_more_content(value, i, search = false) {
        this.dom.load_more = document.querySelector(".js-load-more");

        if (this.dom.load_more) {
            this.dom.load_more.style.display = "inline-block";
        }

        if (search) {
            this.searchItems(
                `${this.endpoint}s=${value}&skip=${i}&take=${this.next}`,
                true
            );
        } else {
            this.getItems(
                `${this.endpoint}s=${value}&skip=${i}&take=${this.next}`,
                true
            );
        }

        this.getCount(
            `${this.endpoint}s=${value}&skip=${this.i + this.next}&take=${
                this.next
            }`
        );
    }

    events() {
        this.dom.load_more.addEventListener("click", () => {
            this.i += this.next;
            this.load_more_content(this.dom.live_search.value, this.i, false);
        });

        this.dom.live_search.addEventListener("keyup", () => {
            this.load_more_content(this.dom.live_search.value, 0, true);
        });
    }

    getCount(url) {
        this.dom.load_more.style.display = "none";

        fetch(url).then(response => {
            response.text().then(html => {
                if (html.length !== 0) {
                    this.dom.load_more = document.querySelector(
                        ".js-load-more"
                    );
                    this.dom.load_more.style.display = "inline-block";
                }
            });
        });
    }

    getItems(url, loadOnClick = false) {
        if (loadOnClick) {
            this.dom.load_more.parentNode.classList.add("loading");
        }

        fetch(url).then(response => {
            response.text().then(html => {
                if (loadOnClick) {
                    this.dom.load_more_container.innerHTML += html;
                } else {
                    this.dom.load_more_container.innerHTML =
                        html === ""
                            ? `<div class="no-items-found"><h3>No items found...</h3></div>`
                            : html;
                }

                this.dom.load_more.parentNode.classList.remove("loading");

                // reinit carousels
                const carousels = document.querySelectorAll("[data-carousel]");

                if (carousels) {
                    carousels.forEach(carouselInit);
                }

                // icon buttons
                window.loadCollectionListeners = loadCollectionListeners;
                window.loadCollectionListeners();
            });
        });
    }

    searchItems(url) {
        fetch(url).then(response => {
            response.text().then(html => {
                if (html.length > 0) {
                    this.dom.load_more_container.innerHTML = html;
                } else {
                    this.dom.load_more_container.innerHTML = `<div class="no-items-found"><h3>No items found...</h3></div>`;
                }

                // reinit carousels
                const carousels = document.querySelectorAll("[data-carousel]");

                if (carousels) {
                    carousels.forEach(carouselInit);
                }

                // icon buttons
                window.loadCollectionListeners = loadCollectionListeners;
                window.loadCollectionListeners();
            });
        });
    }
}
